import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingBasket, Menu, X, User, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useBasket } from "../context/BasketContext";

export const Navbar = () => {
  const { user, isMember, logout } = useAuth();
  const { count } = useBasket();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const links = [
    { to: "/deals", label: "Today's Deals" },
    { to: "/reverse-auction", label: "Reverse Auction" },
    { to: "/coming-soon", label: "Coming Soon" },
    { to: "/how-it-works", label: "How It Works" },
    { to: "/sell-to-us", label: "Sell To Us" },
  ];

  return (
    <header className="sticky top-0 z-40 bg-[#0A0A0A]/95 backdrop-blur-md border-b border-[#27272A]">
      <div className="bg-[#FFCC00] text-black text-[11px] uppercase tracking-widest text-center py-1.5 font-bold">
        One deal a day. Gone when it's gone.
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 flex items-center justify-between h-16">
        <Link to="/" data-testid="nav-logo" className="bg-white px-3 py-1.5 flex items-center shrink-0">
          <img src="/logo.png" alt="UKJobLots — Big Brands. Clearance Prices." className="h-8 sm:h-9 w-auto" />
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-link-${l.to.slice(1)}`} className="text-xs uppercase tracking-widest text-white/60 hover:text-[#FFCC00] transition-colors duration-150">
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          <Link to="/basket" data-testid="nav-basket" className="relative p-2 hover:text-[#FFCC00] transition-colors duration-150">
            <ShoppingBasket size={20} />
            {count > 0 && (
              <span data-testid="basket-count" className="absolute -top-1 -right-1 bg-[#FF3B30] text-white text-[10px] font-bold w-4 h-4 flex items-center justify-center">
                {count}
              </span>
            )}
          </Link>
          {isMember ? (
            <div className="hidden md:flex items-center gap-3">
              {user.role === "admin" && (
                <Link to="/admin" data-testid="nav-admin" className="text-xs uppercase tracking-widest text-[#FF3B30] hover:text-[#FFCC00]">
                  Admin
                </Link>
              )}
              <Link to="/account" data-testid="nav-account" className="flex items-center gap-2 text-xs uppercase tracking-widest text-white/70 hover:text-[#FFCC00]">
                <User size={14} /> {user.name.split(" ")[0]}
              </Link>
              <button data-testid="nav-logout" onClick={() => { logout(); navigate("/"); }} className="text-white/40 hover:text-[#FF3B30] p-1">
                <LogOut size={14} />
              </button>
            </div>
          ) : (
            <Link to="/join" data-testid="nav-join" className="hidden md:block btn-industrial px-5 py-2 text-sm">
              JOIN FREE
            </Link>
          )}
          <button data-testid="nav-mobile-toggle" className="md:hidden p-2" onClick={() => setOpen(!open)}>
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#27272A] bg-[#0A0A0A] px-6 py-6 flex flex-col gap-4">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-sm uppercase tracking-widest text-white/70">
              {l.label}
            </Link>
          ))}
          {isMember ? (
            <>
              {user.role === "admin" && <Link to="/admin" onClick={() => setOpen(false)} className="text-sm uppercase tracking-widest text-[#FF3B30]">Admin</Link>}
              <Link to="/account" onClick={() => setOpen(false)} className="text-sm uppercase tracking-widest text-[#FFCC00]">My Account</Link>
              <button onClick={() => { logout(); setOpen(false); navigate("/"); }} className="text-left text-sm uppercase tracking-widest text-[#FF3B30]">Log out</button>
            </>
          ) : (
            <Link to="/join" onClick={() => setOpen(false)} className="btn-industrial px-5 py-3 text-center text-sm">JOIN FREE</Link>
          )}
        </div>
      )}
    </header>
  );
};
